<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <edit-org-details-form
          header-color="primary"
          v-bind:organization="organization"
          v-bind:ogOrganization="ogOrganization"
          :validationTrigger="validateOrgDetails"
          v-on:validated="lockOrgDetailsValidation"
          v-on:dirty="changed"
        ></edit-org-details-form>
      </div>
      <div class="md-layout-item md-size-100">
        <org-billing-details-form
          v-bind:card="card"
          v-bind:ogCard="ogCard"
          v-on:dirty="changed"
          header-color="primary"
        ></org-billing-details-form>
      </div>
      <div class="md-layout-item md-size-100">
        <org-billing-address-form
          v-bind:card="card"
          v-bind:ogCard="ogCard"
          v-on:dirty="changed"
          :validationTrigger="validateBillingAddress"
          v-on:validated="lockBillingAddressValidation"
          header-color="primary"
        ></org-billing-address-form>
      </div>
    </div>
    <submit-snackbar
      v-bind:validationError="validationError"
      v-bind:dirty="dirty"
      v-bind:errorsOccurred="submitErrorsOccurred"
      v-on:submit="updateConfig"
    ></submit-snackbar>
  </div>
</template>
<script>
import {
  OrgBillingDetailsForm,
  OrgBillingAddressForm,
  EditOrgDetailsForm
} from "@/pages";
import { get } from "vuex-pathify";
import { SubmitSnackbar } from "@/fmComponents";
import { updateOrganization } from "../../utils/appcues";
import validationRules from "../../validationRules";
export default {
  components: {
    SubmitSnackbar,
    OrgBillingDetailsForm,
    OrgBillingAddressForm,
    EditOrgDetailsForm
  },
  computed: {
    validationError: function() {
      return (
        this.$v.organization.$anyError || this.$v.card.card.address.$anyError
      );
    },
    card: function() {
      var card = this.$store.get("card/card");
      var me = this;
      var org = me.$store.get("organization/organization");
      if (
        (card.card.firstName === null || card.card.firstName === "") &&
        (card.card.lastName === null || card.card.lastName === "")
      ) {
        if (
          org.primaryContact.firstName === undefined &&
          org.primaryContact.lastName === undefined
        ) {
          this.$store
            .dispatch(
              "organization/loadOrganization",
              localStorage.organizationId
            )
            .then(() => {
              var org = me.$store.get("organization/organization");
              card.card.firstName = org.primaryContact.firstName;
              card.card.lastName = org.primaryContact.lastName;
              return card;
            });
        } else {
          card.card.firstName = org.primaryContact.firstName;
          card.card.lastName = org.primaryContact.lastName;
          return card;
        }
      }
      return card;
    },
    ogCard: get("card/ogCard"),
    organization: function() {
      var org = this.$store.get("organization/organization");
      if (!org.address) {
        org.address = {};
      }
      return org;
    },
    ogOrganization: function() {
      var ogOrg = this.$store.get("organization/ogOrganization");
      if (!ogOrg.address) {
        ogOrg.address = {};
      }
      return ogOrg;
    },
    submitErrorsOccurred: get("card/errorsOccurred"),
    dirty: function() {
      this.$v.organization.name.$touch();
      this.$v.organization.address.$touch();
      this.$v.card.card.address.$touch();
      return this.getDirtyCard() != null;
    }
  },
  mounted() {
    var card = this.$store.get("card/card");
    if (card.id === "" || card.id === undefined) {
      this.$store.dispatch("card/loadCard");
    }
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    cardDirty: false,
    addressDirty: false,
    orgDirty: false,
    validateBillingAddress: false,
    validateOrgDetails: false
  }),
  created() {},
  methods: {
    lockBillingAddressValidation: function() {
      this.validateBillingAddress = false;
    },
    lockOrgDetailsValidation: function() {
      this.validateOrgDetails = false;
    },
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    updateConfig: function() {
      this.validateBillingAddress = true;
      this.validateOrgDetails = true;
      if (this.validationError) {
        this.$store.commit("pushError", "Your change has one or more errors.");
      } else {
        this.updateCardErrorCount = 0;
        var me = this;
        if (me.cardDirty || me.addressDirty) {
          this.$store.dispatch("card/updateCard", this.getDirtyCard()).then(
            () => {
              me.$store.dispatch("card/loadCard");
              this.cardDirty = false;
              this.addressDirty = false;
            },
            () => {
              //we reset the card to OG so reset dirty flag
              this.cardDirty = false;
              this.addressDirty = false;
            }
          );
        }
        if (me.orgDirty) {
          this.$store
            .dispatch("organization/updateOrganization", me.organization)
            .then(result => {
              updateOrganization(result);
              me.orgDirty = false;
            });
        }
      }
    },
    changed: function(which, dirty) {
      if (which === "card") {
        this.cardDirty = dirty;
      } else if (which === "address") {
        this.addressDirty = dirty;
      } else if (which === "org-address") {
        this.orgDirty = dirty;
      }
    },
    getDirtyCard: function() {
      var me = this;
      if (me.cardDirty || me.addressDirty || me.orgDirty) {
        return me.card;
      }
      return null;
    }
  },
  validations() {
    return validationRules;
  }
};
</script>
